export default __webpack_public_path__ + "static/media/token_OHM.dd9a93aa.svg";